import React from "react";
import classes from "./AidForm.module.css";

//icons
import osta1 from "../../../../images/osta1.png";
import osta2 from "../../../../images/osta2.png";

//Components
import Button from "../../../UI/Button/Button";

//This component displays a form in Giving
const AidForm = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <h4>Khaled El-Osta</h4>
        <p>Khaled, a young man with a very old burden...</p>
        <p>
          Khaled suffered from Birth Asphyxia (lack of oxygen at birth) and had
          become completely blind and paralysed ever since. He cannot sit or
          move independently without the assistance of another person. His
          condition also affected his food intake, as he cannot chew and only
          drinks milk to survive. He is now 30 years old and lives in drastic
          conditions, in a single room apartment with his aunt after his
          mother's passing last year. LWAH has been assisting Khaled with milk
          and other sevices, and he depends on his two married sisters and
          minimal donations, but it has never been enough.
          <br />
          <br />
          If you want to help Khaled, you can either make a donation through
          LWAH or directly contact his sister on 71381717.<br/><br/>
        </p>
        <img src={osta2} alt="osta"/>
        <Button width={200}height={50} className={classes.btn} onClick={props.aidToDonation}>Make A Donation</Button>
      </div>
      <div className={classes.column}>
      <img src={osta1} alt="osta"/>
      </div>
    </div>
  );
};
export default AidForm;